module.exports = __webpack_public_path__ + "static/media/Krispy.c222a9ec.png";